import $ from './app/jquery-shim.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import ScrollReveal from "scrollreveal";
import OwlCarousel from 'owl.carousel';

import fontAwesome from "font-awesome/scss/font-awesome.scss"
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css"
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css"


class App {
  constructor() {
    this.Utils = new Utils();
    this.Accordion = new Accordion();
    this.Anchor = new Anchor();
    this.FixedHeader = new FixedHeader();
    this.HeightLine = new HeightLine();
    this.ResponsiveTable = new ResponsiveTable();
    this.Slidebar = new Slidebar();
    this.CurrentNav = new CurrentNav();
    this.Tab = new Tab();
      // スクロールリーバル
      window.sr = new ScrollReveal({duration: 600,mobile: false});
      sr.reveal(".c-main-visual__image", {scale: 1, duration: 600,distance: '10px',delay: 200}, 100);
      sr.reveal(".c-main-visual__text img", {scale: 1, duration: 600,distance: '16px',origin: 'top',delay: 800}, 100);
      sr.reveal(".c-page-header__inner", {scale: 1, duration: 600,distance: '4px',delay: 100}, 100);
    $(function() {
        var owls = $('.owl-carousel');
        owls.imagesLoaded(function () {
            $('.c-main-visual__slider').owlCarousel({
                items: 1,
                margin: 0,
                dots: true,
                loop: true,
                nav: false,
                autoWidth: false,
                autoplayHoverPause: true,
                autoplay: true,
                center: true,
                autoplaySpeed: 2000,
                animateIn: 'fadeIn',
                animateOut: 'fadeOut',
            });
        });
        $('.l-global-nav__parent').hover(function () {
            $(this).children('.l-global-nav__children').addClass('is-active');
        }, function() {
            $(this).children('.l-global-nav__children').removeClass('is-active');
        });
        $('.l-global-nav__children').hover(function () {
            $(this).parent('.l-global-nav__parent').addClass('is-active');
        }, function() {
            $(this).parent('.l-global-nav__parent').removeClass('is-active');
        });

        var win = $(window).innerWidth();
        if (win > 900) {
            return false;
        }
        $('.c-footer-menu__title.is-parent').on('click',function() {
            return false;
        });
        $('.c-footer-menu__title.is-parent').on('click',function() {
            $(this).parent().toggleClass('is-open');
            $(this).next(".c-footer-menu__list").slideToggle();
        });
    });
  }
}

window.GApp = new App();
